import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  line-height: 24px;
  font-size: 14px;
`;
